import { all, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ONBOARDING_CONFIG_REQUEST,
  UPDATE_ONBOARDING_CONFIG_REQUEST
} from '../../actions/onboardingConfigActions';
import {
  fetchOnboardingConfigSaga,
  updateOnboardingConfigSaga
} from '../onboardingConfigSaga';

import {
  FETCH_ONBOARDING_SPONSOR_CONFIG_REQUEST,
  UPDATE_ONBOARDING_SPONSOR_CONFIG_REQUEST
} from '../../actions/onboardingSponsorConfigActions';
import {
  fetchOnboardingSponsorConfigSaga,
  updateOnboardingSponsorConfigSaga
} from '../onboardingSponsorConfigSaga';

export default function* onboardingRootSaga() {
  yield all([
    takeLatest(FETCH_ONBOARDING_CONFIG_REQUEST, fetchOnboardingConfigSaga),
    takeLatest(UPDATE_ONBOARDING_CONFIG_REQUEST, updateOnboardingConfigSaga),
    takeLatest(FETCH_ONBOARDING_SPONSOR_CONFIG_REQUEST, fetchOnboardingSponsorConfigSaga),
    takeLatest(UPDATE_ONBOARDING_SPONSOR_CONFIG_REQUEST, updateOnboardingSponsorConfigSaga)
  ]);
}

